import React from 'react';
import PropTypes from 'prop-types';

const DrawerContainer = ({ children, backgroundColor }) => {
  return (
    <div id="drawer-container" style={{ backgroundColor: backgroundColor }} className="drawer-container">
      {children}
    </div>
  );
};

DrawerContainer.propTypes = {
  children: PropTypes.object,
  backgroundColor: PropTypes.string
};

export default DrawerContainer;
